import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import cn from 'classnames';
import DeviationLink from '../../../Duperbrowse/DeviationLink';
import cleanLinkSrc from '../../../utils/xss/cleanLinkSrc';
import s from './DeviationLink.scss';
const getUrl = (url)=>{
    if (!/^http/.test(url)) {
        return `http://${url}`;
    }
    return url;
};
const EditorDeviationLink = ({ className, style, link, deviation, children })=>{
    const linkProps = {
        className: cn(s['link'], className),
        style
    };
    return link ? /*#__PURE__*/ React.createElement("a", _object_spread_props(_object_spread({}, linkProps), {
        href: cleanLinkSrc(getUrl(link.url)),
        rel: "nofollow noopener"
    }), children) : /*#__PURE__*/ React.createElement(DeviationLink, _object_spread_props(_object_spread({}, linkProps), {
        deviation: deviation,
        canLinkToStash: deviation.isJournal
    }), children);
};
EditorDeviationLink.displayName = 'EditorDeviationLink';
export default EditorDeviationLink;
